module.exports = __webpack_public_path__ + "static/media/menu.be84216a.svg";